import dynamic from "next/dynamic";
const App = dynamic(() => import("../components/App"));
import React from "react";
import Head from "next/head";
import { Breadcrumb, Space, Typography, Row, Col } from "antd";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import Link from "next/link";

const { Title, Text } = Typography;

export async function getServerSideProps(ctx) {
  return {
    props: {
      ...(await serverSideTranslations(ctx?.locale, ["common"])),
      token: ctx?.req?.cookies?.token || null,
    },
  };
}

const Home = ({
  token,
  categoryMenu,
  hasSale,
  hasLive,
  dataSeo,
  dataReferrer,
}) => {
  const router = useRouter();
  const { locale } = router;
  let queryParam = router?.query?.aid ? `aid=${router?.query?.aid}` : ``;
  queryParam = router?.query?.pid
    ? `${queryParam}&pid=${router?.query?.pid}`
    : queryParam;

  queryParam = router?.query?.pf
    ? `${queryParam}pf=${router?.query?.pf}`
    : queryParam;

  if (router?.query?.utm_source) {
    queryParam = queryParam
      ? `${queryParam}&utm_source=${router?.query?.utm_source}`
      : `?utm_source=${router?.query?.utm_source}`;
  }

  const { t } = useTranslation("common");

  const ComponentTh = () => {
    return (
      <Space direction="vertical" size={`large`} style={{ marginTop: 24 }}>
        <p className="h4">ยินดีต้อนรับสู่ LUXURY29</p>
        <Text>
          ร้านมัลติแบรนด์ครบวงจรของคุณที่ตั้งอยู่ใจกลางเมืองกรุงเทพฯ ตรงข้าม
          สยามพารากอน
          เรามุ่งมั่นที่จะมอบประสบการณ์สุดว้าวให้กับลูกค้าของเราทุกคนด้วยความสะดวกสบายในการจัดหาทุกความต้องการสำหรับการช้อปปิ้งของคุณในร้านค้าสุดหรูแห่งเดียว
          Luxury29 เป็นตัวอย่างที่ดีของความพิเศษ
          แนวคิดใหม่ที่คุณสามารถดื่มด่ำกับผลิตภัณฑ์จากดีไซเนอร์ที่หลากหลาย
          เราให้บริการคอลเลกชั่นเสื้อผ้าแบรนด์ดีไซเนอร์ระดับไฮเอนด์มากมายทั้งสำหรับชายและหญิง
          รองเท้าลิมิเต็ดเอดิชั่นสุดประณีต รวมถึงเครื่องประดับ นาฬิกา กระเป๋า
          และเครื่องหนังล้ำค่า
          บนชั้นสองเรามีห้องวีไอพีส่วนตัวที่ได้รับการตกแต่งอย่างหรูหราจำนวน 2
          ห้อง เพื่อให้คำปรึกษาแบบตัวต่อตัว
          และมอบประสบการณ์การช็อปปิ้งที่ปรับให้เหมาะกับคุณโดยเฉพาะ
          คำมั่นสัญญาของเราคือการให้บริการลูกค้าด้วยคุณภาพสูงสุดเสมอ
          เราเป็นจุดหมายปลายทางสำหรับความหรูหราที่แท้จริง
        </Text>
        <Space direction="vertical" size={`small`}>
          <Text></Text>
          <Text>
            บริษัท แอลเอ็กวาย 36 จำกัด
            <br />
            200 อาคารจัสมิน อินเตอร์เนชั่นแนล ชั้น 31 หมู่ 4 ถนนแจ้งวัฒนะ
            ตำบลปากเกร็ด อำเภอปากเกร็ด จังหวัดนนทบุรี 11120 ประเทศไทย
          </Text>
        </Space>
      </Space>
    );
  };

  const ComponentEn = () => {
    return (
      <Space direction="vertical" size={`large`} style={{ marginTop: 24 }}>
        <p className="h4">Welcome to LUXURY29</p>
        <Text>
          Your one stop multi brand store situated in the heart of downtown
          Bangkok opposite Siam Paragon. We aim to provide the ultimate wow
          experience to all our clients, with the comfort to procure all your
          shopping desires in one luxurious store. Luxury29 is the epitome of
          exclusivity, a new concept where you can indulge in an extensive range
          of designer products. We cater a vast collection of high end designer
          clothing brands for both men and women, including exquisite limited
          edition footwear as well as precious jewelry, watches, bags and
          leather goods. We have a dedicated second floor, which features two
          extravagant appointed private VIP rooms, offering bespoke one-to-one
          consultations to provide you with a personally tailored shopping
          experience. Our promise is to always provide our clients of the
          highest quality of service. We are the destination for authenticated
          luxury.
        </Text>
        <Space direction="vertical" size={`small`}>
          <Text>
            LXY36 Co.,Ltd. (Head Office)
            <br />
            200 Jasmine International Tower, 31st Moo4 Chaengwattana Road,
            Tambol Pakkret, Amphur Pakkret, Nonthaburi Province 11120, Thailand
          </Text>
        </Space>
      </Space>
    );
  };

  return (
    <App
      token={token}
      categoryMenu={categoryMenu}
      hasSale={hasSale}
      hasLive={hasLive}
      dataSeo={dataSeo}
      dataReferrer={dataReferrer}
    >
      <Head>
        <title>About Us</title>
      </Head>
      <Row justify="center" style={{ marginBlock: 24 }}>
        <Col
          xs={22}
          sm={22}
          md={22}
          lg={22}
          xl={20}
          style={{ textAlign: "center" }}
        >
          <Breadcrumb
            style={{ marginBottm: 24 }}
            items={[
              {
                key: "home",
                title: (
                  <Link href={`/${queryParam ? `?${queryParam}` : ``}`}>
                    {t("home")}
                  </Link>
                ),
              },
              {
                key: "about",
                title: `${t("about")}`,
              },
            ]}
          />
          {locale == "th" ? <ComponentTh /> : <ComponentEn />}
        </Col>
      </Row>
    </App>
  );
};

export default Home;
